import { IMockProps, ErrorResponseCodeType } from '_core/types';
import MocksDef from './MocksDef';

import { CODE_ERRORS, ENDPOINT_API_PATH } from '../Definitions/MemberStatusDef';

const autoGenerateSuccess = (login: string) => {
  const loginData =
    login.indexOf('@') >= 0 ? 'EMAIL' : login.length === 11 ? 'CPF' : 'MEMBER';

  let bodyRequest = {};
  switch (loginData) {
    case 'EMAIL':
      bodyRequest = {
        email: login,
      };
      break;
    case 'CPF':
      bodyRequest = {
        document: {
          type: 'CPF',
          value: login,
        },
      };
      break;
    case 'MEMBER':
      bodyRequest = {
        memberNumber: login,
      };
      break;
  }

  const accountStatusSuccess: IMockProps = {
    doc: {
      code: 'Enviado com Sucesso',
      message: 'Enviado com Sucesso',
    },
    configRequest: {
      method: 'POST',
      path: ENDPOINT_API_PATH,
      body: {
        ...bodyRequest,
      },
    },
    configResponse: {
      status: 200,
      data: {
        status: loginData === 'EMAIL' ? 'CANCELLED' : 'ACTIVE',
      },
      headers: {},
    },
  };
  return accountStatusSuccess;
};

const autoGenerateSuccessMemberNumber = autoGenerateSuccess(
  MocksDef.MEMBER_NUMBER,
);
const autoGenerateSuccessCPF = autoGenerateSuccess(MocksDef.DOCUMENT_TYPE.CPF);
const autoGenerateSuccessEmail = autoGenerateSuccess(MocksDef.EMAIL);

const generatedSuccessMocks = [
  autoGenerateSuccessMemberNumber,
  autoGenerateSuccessCPF,
  autoGenerateSuccessEmail,
];

const autoGenerate = (login: string) => {
  const listOfErrorsMock: IMockProps[] = CODE_ERRORS.map(
    (error: ErrorResponseCodeType, index: number) => {
      const formatedError: IMockProps = {
        doc: {
          code: error.code,
          message: error.message,
        },
        configRequest: {
          method: 'POST',
          path: ENDPOINT_API_PATH,
          body: {
            email: `${index}-${login}`,
          },
        },
        configResponse: {
          status: 452,
          data: {
            code: error.code,
            message: error.message,
          },
          headers: {},
        },
      };

      return formatedError;
    },
  );
  return listOfErrorsMock;
};
const autoGenerateErrorsMock = () => {
  const responseError = autoGenerate(MocksDef.EMAIL);
  return [...responseError];
};

const errorsGenerated = autoGenerateErrorsMock();

const CreateMember = [...generatedSuccessMocks, ...errorsGenerated];
export default CreateMember;
